import React from 'react';
import {Container} from "react-bootstrap";
import {Helmet} from "react-helmet";

function PrivacyPolicy() {

    return (
        <div>
            <Helmet>
                <title>Політика конфіденційності - zapauto.com.ua</title>
                <meta name="description" content="Політика конфіденційності zapauto.com.ua"/>
            </Helmet>

            <section style={{ padding: "40px 0" }}>
                <Container style={{ lineHeight: "1.6", fontSize: "15px" }}>

                    <h2>ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ</h2>

                    <p>
                        Ця Політика конфіденційності визначає порядок обробки та захисту персональних даних користувачів сайту https://zapauto.com.ua/ (далі — «Сайт»).
                    </p>

                    <h4>1. Загальні положення</h4>

                    <p>1.1. Володільцем персональних даних є ФОП Коновал Ярослав Русланович.</p>

                    <p>
                        1.2. Користуючись Сайтом, Користувач надає згоду на обробку своїх персональних даних відповідно до цієї Політики та Закону України «Про захист персональних даних».
                        Користувач підтверджує, що повідомлений про свої права.
                    </p>

                    <h4>2. Які дані ми збираємо</h4>

                    <p>2.1. Ми можемо збирати такі персональні дані:</p>

                    <ul>
                        <li>ім’я та прізвище</li>
                        <li>номер телефону</li>
                        <li>адресу доставки</li>
                        <li>електронну пошту (за наявності)</li>
                        <li>іншу інформацію, яку Користувач надає добровільно</li>
                    </ul>

                    <h4>3. Мета обробки даних</h4>

                    <p>3.1. Персональні дані обробляються з метою:</p>

                    <ul>
                        <li>оформлення та виконання замовлень</li>
                        <li>зв’язку з Користувачем</li>
                        <li>доставки товарів</li>
                        <li>здійснення взаєморозрахунків</li>
                        <li>ведення обліку операцій</li>
                        <li>виконання умов договору (публічної оферти)</li>
                    </ul>

                    <h4>4. Передача персональних даних</h4>

                    <p>4.1. Персональні дані можуть передаватися третім особам виключно з метою виконання замовлення, зокрема:</p>

                    <ul>
                        <li>службам доставки (Nova Poshta та інші)</li>
                        <li>платіжним сервісам</li>
                        <li>партнерам (продавцям), які беруть участь у виконанні замовлення</li>
                    </ul>

                    <p>4.2. Передача даних здійснюється лише в обсязі, необхідному для виконання замовлення.</p>

                    <h4>5. Захист персональних даних</h4>

                    <p>5.1. Продавець вживає необхідних заходів для захисту персональних даних.</p>

                    <p>
                        5.2. Продавець не несе відповідальності за розголошення даних, якщо це сталося поза його контролем
                        або внаслідок дій користувача.
                    </p>

                    <p>
                        5.3. Сайт може використовувати сторонні сервіси аналітики (наприклад Google Analytics).
                    </p>

                    <h4>6. Строк зберігання даних</h4>

                    <p>
                        6.1. Персональні дані зберігаються протягом строку, необхідного для досягнення цілей обробки,
                        або відповідно до законодавства України.
                    </p>

                    <h4>7. Права користувача</h4>

                    <p>7.1. Користувач має право:</p>

                    <ul>
                        <li>знати про джерела збору своїх даних</li>
                        <li>вимагати уточнення або видалення даних</li>
                        <li>відкликати згоду на обробку</li>
                        <li>отримувати інформацію про обробку</li>
                        <li>отримувати доступ до своїх даних</li>
                    </ul>

                    <p>7.2. Користувач несе відповідальність за достовірність даних.</p>

                    <h4>8. Cookie</h4>

                    <p>
                        8.1. Сайт може використовувати файли cookie для коректної роботи та аналітики.
                    </p>

                    <h4>9. Зміни до політики</h4>

                    <p>9.1. Продавець має право змінювати Політику.</p>
                    <p>9.2. Актуальна версія завжди доступна на сайті.</p>

                    <h4>10. Контактна інформація</h4>

                    <p>ФОП Коновал Ярослав Русланович</p>
                    <p>ІПН 3513005235</p>
                    <p>Телефон: +380986755053</p>

                </Container>
            </section>

        </div>
    )
}

export default PrivacyPolicy;